<template>
    <div>
        <h3 class="is-size-3">Valores para Puntaje Crediticio</h3>
        <p>
            <code>POST {{ host }}/api/firaCreditScoreEvaluation</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint recibe cuatro parámetros obligatorios:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>anexo</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Anexo a consultar (21 o 22)</li>
                    </ul>
                </li>
                <li>
                    <strong>industria_grupo</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Numerico</li>
                    </ul>
                </li>
                <li>
                    <strong>id_indicador_grupo</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Numerico</li>
                    </ul>
                </li>
                <li>
                    <strong>valor</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Numerico</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe la solicitud en formato JSON:
        </h5>
        <pre>
        <code>
            {
                "anexo": 21,
                "industria_grupo": 1,
                "id_indicador_grupo": 1,
                "valor": 0.12
            }
        </code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            {
                "id_indicador_grupo": 1,
                "factor_riesgo": "I-A",
                "indicador": "Porcentaje de pagos en tiempo con entidades financieras bancarias en los últimos 12 meses",
                "rango_inferior": "0.000",
                "rango_superior": "0.730",
                "puntaje": "65.00"
            }
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>